<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/campaign-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Cambiar estado</h4><h6 class="color-gray" style="font-weight: 400;">Selecciona el nuevo estado de esta campaña.</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="prospect-form mt-3">
                <div>
                    <label class="login-label" for="nueva_fecha"><p class="color-org d-inline">*</p> Estado:</label> 
                    <select name="" id="" class="crm-input">
                        @for (item of statusList; track item) {
                            <option [value]="item.id_estado">{{ item.nombre }}</option>
                        }
                    </select>
                </div>
            </div>
            <hr class="mt-3">
            <div class="d-flex flex-row justify-center gap-20 mt-3">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button class="btn btn-primary text-center" (click)="saveStatus();">Guardar cambio</button>
            </div>
        </div>  
    </div>
</div>